import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Project from "../components/Project.vue";
import Proposal from "../components/Proposal.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/getinvolved",
    name: "GetInvolved",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/GetInvolved.vue")
  },
  {
    path: "/proposal/:slug",
    component: Proposal
    // name: "Proposal",
    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/Proposal.vue")
  },
  {
    path: "/addproject",
    name: "AddProject",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AddProject.vue")
  },
  {
    path: "/project/:slug",
    component: Project
    // name: 'Project',
    // component: () => import("../components/Project.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    if (document.querySelector(".project-section--hero ")) {
      document
        .querySelector(".project-section--hero ")
        .scrollIntoView({ behavior: "instant" });
    }
  }
});

export default router;
